import { FormBuilder, FormControl } from '@angular/forms';
import { CalendarTranslateService } from './../../services/calendarTranslate.service';
import { Component, Input, OnInit, Output, EventEmitter, ViewChildren, AfterViewInit, QueryList, SimpleChanges, OnChanges, AfterContentChecked } from '@angular/core';
import { QueryBuilderConfig } from 'angular2-query-builder';
import * as moment from 'moment';
import { Calendar } from 'primeng/primeng';

@Component({
  selector: 'app-kv-ext-search',
  templateUrl: './kv-ext-search.component.html',
  styleUrls: ['./kv-ext-search.component.css']
})
export class KvExtSearchComponent implements OnInit,AfterContentChecked {
  ctrl: FormControl;
  submitted = false;
  @Input() query: any;
  @Input() config: QueryBuilderConfig;
  @Input() showSendQueryBtn = true;
  @Input() openedAccordion = false;
  @Output() extSearchReq: EventEmitter<any> = new EventEmitter();
  @ViewChildren('dateFieldRef') dateFieldRef: Calendar[];
  @ViewChildren('dateFieldRefStart') dateFieldRefStart: Calendar[];
  @ViewChildren('dateFieldRefEnd') dateFieldRefEnd: Calendar[];

  constructor(
    public srvCalendarTranslate: CalendarTranslateService,
    private fb: FormBuilder
  ) {
    this.ctrl = this.fb.control(this.query);
  }

  ngOnInit() {
    const validator = (rule) => {
      if (!rule.value) {
        return {
          rule: rule,
          message: 'Campo obbligatorio'
        }
      }
    };
    for (const field in this.config.fields) {
      Object.assign(this.config.fields[field], {validator});
      if (this.config.fields[field].type === 'date') {
        Object.assign(this.config.fields[field], {dateValue: ''});
      }
    }

  }
  resetModelDate() {

    if (this.query && this.query.rules) {
      this.query.rules.forEach(rule => {
        let type = rule.field?this.config.fields[rule.field].type:"";
        if(type == "date" || type == "number"){
          rule.datevalue = null;
          rule.startValue = null;
          rule.endValue = null;
        }

        if (rule.operator === 'between' && !Array.isArray(rule.value)) {
          rule.value = [null, null];
        }

      });
    }
  }
  ngAfterContentChecked(): void {
    this.resetModelDate();
  }
  convertDate(rule,ref,type) {
    //modificata perchè non sbiancava il valore delle date, cambiato anche nell'html l'ngModel, con singolo binding
    let valueDate = ref.value;
    if(type=="dateValue"){
      rule.value = moment(valueDate).format('YYYY-MM-DD');
    }
    else if(type=="startValue" || type=="endValue"){

      if (rule.operator === 'between') {
        if(!rule.value){
         rule.value = [null,null];
        }

        if(type=="startValue" && rule.value){
          rule.value[0] = moment(valueDate).format('YYYY-MM-DD');
        }
        else if(type=="endValue"){
          rule.value[1] = moment(valueDate).format('YYYY-MM-DD');
        }
      }
    }

  }
  convertNumber(rule,ref,type)  {

    let valueNumber = ref.value;

    if (rule.operator === 'between') {
      if(!rule.value){
       rule.value = [null,null];
      }

      if(type=="startValue"){
        rule.value[0] = valueNumber;
      }
      else if(type=="endValue"){
        rule.value[1] = valueNumber;
      }
    }

  }
  sendQuery() {
    this.submitted = true;
    this.ctrl.updateValueAndValidity();
    if (this.ctrl.valid) {
      this.extSearchReq.emit(this.query);
    }
  }
  /**
   * Il jolly % viene già aggiunto dal BE nelle condizioni LIKE: impedisco di digitarlo
   */
  blockWildcard(event: KeyboardEvent) {
    if (event.key === '%') {
      event.preventDefault();
    }
  }

  /**
   * Rimuove il % anche da incolla/trascinamento e query caricate
   */
  removeWildcard(value: any) {
    return typeof value === 'string' ? value.replace(/%/g, '') : value;
  }

  /**
   * Ripulisce il valore mostrato nell'input
   * se il valore pulito coincide con quello già presente nel modello
   */
  cleanWildcardInput(event: Event) {
    const input = event.target as HTMLInputElement;
    if (input.value.indexOf('%') > -1) {
      const caret = input.selectionStart - (input.value.length - input.value.replace(/%/g, '').length);
      input.value = this.removeWildcard(input.value);
      input.setSelectionRange(caret, caret);
    }
  }

  public controlOperator(operator: string) {
    if(operator === 'exists' || operator === 'not exists' || operator === 'esiste' || operator === 'non esiste') {
      return false;
    } else {
      return true;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/UIKit/components/kv-ext-search/kv-ext-search.component.ts